import { format, isSameDay } from 'date-fns';

import { Dates } from 'context/DateProvider/DateProvider';

export const getFormattedDate = (dateTimeRange: Dates, formatString: string) => {
  const fromDate = new Date(dateTimeRange.from);
  const toDate = new Date(dateTimeRange.to);

  if (isSameDay(fromDate, toDate)) {
    return format(fromDate, formatString);
  }
  return `${format(fromDate, formatString)} - ${format(toDate, formatString)}`;
};
